export const ROW_PAYMENTS = geo => {
  return [
    {
      id: 519,
      country_code: ['LV', 'SE', 'DK', 'IE', 'DE', 'AT', 'CH', geo],
      image: {
        data: {
          id: 282,
          attributes: {
            name: 'visa.svg',
            alternativeText: null,
            caption: null,
            width: 47,
            height: 32,
            formats: null,
            hash: 'visa_fe84cdf5fc',
            ext: '.svg',
            mime: 'image/svg+xml',
            size: 1.92,
            url: 'https://cdn-cms.spinwise.com/visa_fe84cdf5fc.svg',
            previewUrl: null,
            provider: '@strapi-community/strapi-provider-upload-google-cloud-storage',
            provider_metadata: null,
            createdAt: '2023-08-15T10:22:34.184Z',
            updatedAt: '2023-08-15T10:22:34.184Z',
          },
        },
      },
    },
    {
      id: 522,
      country_code: ['LV', 'SE', 'DK', 'IE', 'DE', 'AT', 'CH', geo],
      image: {
        data: {
          id: 283,
          attributes: {
            name: 'mastercard.svg',
            alternativeText: null,
            caption: null,
            width: 125,
            height: 32,
            formats: null,
            hash: 'mastercard_bbb2ef0cb9',
            ext: '.svg',
            mime: 'image/svg+xml',
            size: 9.22,
            url: 'https://cdn-cms.spinwise.com/mastercard_bbb2ef0cb9.svg',
            previewUrl: null,
            provider: '@strapi-community/strapi-provider-upload-google-cloud-storage',
            provider_metadata: null,
            createdAt: '2023-08-15T10:22:34.198Z',
            updatedAt: '2023-08-15T10:24:36.959Z',
          },
        },
      },
    },
    {
      id: 517,
      country_code: ['SE', 'LV', geo],
      image: {
        data: {
          id: 285,
          attributes: {
            name: 'bank-transfer.svg',
            alternativeText: null,
            caption: null,
            width: 122,
            height: 32,
            formats: null,
            hash: 'bank_transfer_904ed1a1dc',
            ext: '.svg',
            mime: 'image/svg+xml',
            size: 10.63,
            url: 'https://cdn-cms.spinwise.com/bank_transfer_904ed1a1dc.svg',
            previewUrl: null,
            provider: '@strapi-community/strapi-provider-upload-google-cloud-storage',
            provider_metadata: null,
            createdAt: '2023-08-15T10:23:45.198Z',
            updatedAt: '2023-08-15T10:23:45.198Z',
          },
        },
      },
    },
    {
      id: 518,
      country_code: ['LV', 'SE'],
      image: {
        data: {
          id: 284,
          attributes: {
            name: 'ezeewallet.svg',
            alternativeText: null,
            caption: null,
            width: 110,
            height: 32,
            formats: null,
            hash: 'ezeewallet_7be28051b5',
            ext: '.svg',
            mime: 'image/svg+xml',
            size: 11.01,
            url: 'https://cdn-cms.spinwise.com/ezeewallet_7be28051b5.svg',
            previewUrl: null,
            provider: '@strapi-community/strapi-provider-upload-google-cloud-storage',
            provider_metadata: null,
            createdAt: '2023-08-15T10:22:34.294Z',
            updatedAt: '2023-08-15T10:22:34.294Z',
          },
        },
      },
    },
    {
      id: 525,
      country_code: ['LV', 'SE', 'DE', 'AT', 'CH', geo],
      image: {
        data: {
          id: 286,
          attributes: {
            name: 'jeton.svg',
            alternativeText: null,
            caption: null,
            width: 82,
            height: 32,
            formats: null,
            hash: 'jeton_686141f717',
            ext: '.svg',
            mime: 'image/svg+xml',
            size: 5.68,
            url: 'https://cdn-cms.spinwise.com/jeton_686141f717.svg',
            previewUrl: null,
            provider: '@strapi-community/strapi-provider-upload-google-cloud-storage',
            provider_metadata: null,
            createdAt: '2023-08-15T10:23:53.686Z',
            updatedAt: '2023-08-15T10:23:53.686Z',
          },
        },
      },
    },
    {
      id: 523,
      country_code: ['LV', 'DE', 'AT', 'CH', geo],
      image: {
        data: {
          id: 287,
          attributes: {
            name: 'mifinity.svg',
            alternativeText: null,
            caption: null,
            width: 99,
            height: 32,
            formats: null,
            hash: 'mifinity_f8f328919a',
            ext: '.svg',
            mime: 'image/svg+xml',
            size: 12.32,
            url: 'https://cdn-cms.spinwise.com/mifinity_f8f328919a.svg',
            previewUrl: null,
            provider: '@strapi-community/strapi-provider-upload-google-cloud-storage',
            provider_metadata: null,
            createdAt: '2023-08-15T10:24:02.037Z',
            updatedAt: '2023-08-15T10:24:02.037Z',
          },
        },
      },
    },
    {
      id: 520,
      country_code: ['LV'],
      image: {
        data: {
          id: 281,
          attributes: {
            name: 'astropay.svg',
            alternativeText: null,
            caption: null,
            width: 67,
            height: 32,
            formats: null,
            hash: 'astropay_81e322ea69',
            ext: '.svg',
            mime: 'image/svg+xml',
            size: 5.1,
            url: 'https://cdn-cms.spinwise.com/astropay_81e322ea69.svg',
            previewUrl: null,
            provider: '@strapi-community/strapi-provider-upload-google-cloud-storage',
            provider_metadata: null,
            createdAt: '2023-08-15T10:22:34.180Z',
            updatedAt: '2023-08-15T12:56:56.395Z',
          },
        },
      },
    },
    {
      id: 521,
      country_code: ['LV', 'DK', 'IE', 'DE', 'AT', 'CH', geo],
      image: {
        data: {
          id: 317,
          attributes: {
            name: 'skrill.svg',
            alternativeText: null,
            caption: null,
            width: 49,
            height: 32,
            formats: null,
            hash: 'skrill_4d02b3db49',
            ext: '.svg',
            mime: 'image/svg+xml',
            size: 1.66,
            url: 'https://cdn-cms.spinwise.com/skrill_4d02b3db49.svg',
            previewUrl: null,
            provider: '@strapi-community/strapi-provider-upload-google-cloud-storage',
            provider_metadata: null,
            createdAt: '2023-08-23T10:37:58.172Z',
            updatedAt: '2023-08-23T10:37:58.172Z',
          },
        },
      },
    },
    {
      id: 526,
      country_code: ['LV', 'DK', 'IE', 'DE', 'AT', 'CH', geo],
      image: {
        data: {
          id: 318,
          attributes: {
            name: 'neteller.svg',
            alternativeText: null,
            caption: null,
            width: 68,
            height: 32,
            formats: null,
            hash: 'neteller_2e848dc462',
            ext: '.svg',
            mime: 'image/svg+xml',
            size: 1.31,
            url: 'https://cdn-cms.spinwise.com/neteller_2e848dc462.svg',
            previewUrl: null,
            provider: '@strapi-community/strapi-provider-upload-google-cloud-storage',
            provider_metadata: null,
            createdAt: '2023-08-23T10:37:58.267Z',
            updatedAt: '2023-08-23T10:37:58.267Z',
          },
        },
      },
    },
    {
      id: 524,
      country_code: ['DK', 'LV'],
      image: {
        data: {
          id: 319,
          attributes: {
            name: 'trustly.svg',
            alternativeText: null,
            caption: null,
            width: 89,
            height: 32,
            formats: null,
            hash: 'trustly_c2ddcad70d',
            ext: '.svg',
            mime: 'image/svg+xml',
            size: 2,
            url: 'https://cdn-cms.spinwise.com/trustly_c2ddcad70d.svg',
            previewUrl: null,
            provider: '@strapi-community/strapi-provider-upload-google-cloud-storage',
            provider_metadata: null,
            createdAt: '2023-08-23T10:37:58.273Z',
            updatedAt: '2023-08-23T10:37:58.273Z',
          },
        },
      },
    },
    {
      id: 527,
      country_code: ['LV', 'IE', 'DE', 'AT', 'CH', geo],
      image: {
        data: {
          id: 320,
          attributes: {
            name: 'rapid.svg',
            alternativeText: null,
            caption: null,
            width: 70,
            height: 32,
            formats: null,
            hash: 'rapid_b971142c20',
            ext: '.svg',
            mime: 'image/svg+xml',
            size: 32.01,
            url: 'https://cdn-cms.spinwise.com/rapid_b971142c20.svg',
            previewUrl: null,
            provider: '@strapi-community/strapi-provider-upload-google-cloud-storage',
            provider_metadata: null,
            createdAt: '2023-08-23T10:37:58.279Z',
            updatedAt: '2023-08-23T10:37:58.279Z',
          },
        },
      },
    },
    {
      id: 528,
      country_code: ['LV', 'DK', 'IE', 'DE', 'AT', 'CH', geo],
      image: {
        data: {
          id: 316,
          attributes: {
            name: 'paysafecard.svg',
            alternativeText: null,
            caption: null,
            width: 111,
            height: 32,
            formats: null,
            hash: 'paysafecard_3ade270da6',
            ext: '.svg',
            mime: 'image/svg+xml',
            size: 8.64,
            url: 'https://cdn-cms.spinwise.com/paysafecard_3ade270da6.svg',
            previewUrl: null,
            provider: '@strapi-community/strapi-provider-upload-google-cloud-storage',
            provider_metadata: null,
            createdAt: '2023-08-23T10:37:58.161Z',
            updatedAt: '2023-08-23T10:37:58.161Z',
          },
        },
      },
    },
    {
      id: 577,
      country_code: ['DE', 'AT'],
      image: {
        data: {
          id: 3601,
          attributes: {
            name: 'sofort-gokhan2.svg',
            alternativeText: null,
            caption: null,
            width: 91,
            height: 32,
            formats: null,
            hash: 'sofort_gokhan2_e3a0d39ce8',
            ext: '.svg',
            mime: 'image/svg+xml',
            size: 16.07,
            url: 'https://cdn-cms.spinwise.com/sofort_gokhan2_e3a0d39ce8.svg',
            previewUrl: null,
            provider: '@strapi-community/strapi-provider-upload-google-cloud-storage',
            provider_metadata: null,
            createdAt: '2025-05-07T07:23:17.038Z',
            updatedAt: '2025-05-07T07:23:17.038Z',
          },
        },
      },
    },
  ];
};
